import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Validators, FormBuilder, FormGroupDirective } from '@angular/forms';
import { ValidateEnrolService } from '../../service/validating-enrollee/validate-enrol.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { ValidatingEnroleeMessage } from 'src/app/utility/services/message/custom-messages';
import { AppContentMessage } from '../../model/appContentMessage';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-validate-enrol',
  templateUrl: './validate-enrol.component.html',
  styleUrls: ['./validate-enrol.component.scss']
})
export class ValidateEnrolComponent implements OnInit {

  birthYearRegularExpression = "^[0-9]{1,6}";
  otpFlag = false;
  timeLeft = 120;
  private browserId: string;
  subscribeTimer: any;
  message: any;
  isOtpGenerate = false;
  enrolId: number;
  groupPolicyNo: string;
  groupPolicyName: string;
  certificateNo: string;
  birthYear: number;
  customMessage = new ValidatingEnroleeMessage();
  otpFromDirective: FormGroupDirective;
  validateEnrolFromDirective: FormGroupDirective;
  productList: any[] = [];
  relationList: any = [];
  dependentProducts: any = [];
  insuredName: string;
  requestToken: string;
  recaptchaToken: string;
  recaptchaEnabled = environment.enableCaptcha;

  @Input() set isParentTabSelectionChange(value) {
    if (value) {
      this.clearTimer();
      this.resetFromSettings();
      this.resetIsParentTabSelectionChangeValue.emit();
    }
  }
  @Output() resetIsParentTabSelectionChangeValue = new EventEmitter<any>();
  @Output() onValidOTP = new EventEmitter<any>();

  validateEnrolForm = this.fb.group({
    groupPolicyNo: [null, [Validators.required]],
    certificateNo: [null, [Validators.required]],
    birthYear: [null, [Validators.required, Validators.pattern(this.birthYearRegularExpression)]],
    recaptcha: [null,  this.recaptchaEnabled ? [Validators.required] : []],
  });
  otpForm = this.fb.group({
    otpNumber: [null, [Validators.required]],
    enrolId: [0]
  });
  constructor(
    private fb: FormBuilder,
    private validateEnrolService: ValidateEnrolService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    this.timeLeft = this.customMessage.otpLeftTime;
  }

  genarateOTP(formDirective1: FormGroupDirective) {
    this.validateEnrolFromDirective = formDirective1;
    this.otpFlag = false;
    const entity = this.validateEnrolForm.value;
    // this Customize work should be revert. It is only for skipping Otp generation after first time
    //  this.otpFlag = true;
    //  this.isOtpGenerate = !this.isOtpGenerate;
    //  this.message = "Code has been sent this phone number.";
    //  this.enrolId = 20;
    //  this.browserId = "MTMwNjA=";
    //  this.startTimer();
    //  this.groupPolicyNo = entity.groupPolicyNo;
    //  this.certificateNo = entity.certificateNo;
    //  this.birthYear = entity.birthYear;

    //  this.otpForm.patchValue({
    //   enrolId: 20
    // });

    this.validateEnrolService
      .findClaim(entity.groupPolicyNo, entity.birthYear, entity.certificateNo, entity.recaptcha)
      .subscribe(
        res => {
          if (res.status != AppContentMessage.RESPONSE_STATUS_SUCCESS) {
            this.messageService.show(res.msg, "error");
            return;
          }
          this.otpFlag = true;
          this.isOtpGenerate = !this.isOtpGenerate;
          this.message = res.msg;
          this.enrolId = res.data.res.id;
          this.browserId = res.data.res.browserId;
          this.requestToken = res.data.res.requestToken;
          sessionStorage.setItem('requestToken', res.data.res.requestToken);
          this.startTimer();
          this.groupPolicyNo = entity.groupPolicyNo;
          //this.groupPolicyName = res.data.res[0].groupPolicy.organization.name;
          this.certificateNo = entity.certificateNo;
          this.birthYear = entity.birthYear;

          this.otpForm.patchValue({
            enrolId: res.data.res.id
          });
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      );
  }

  startTimer() {
    this.subscribeTimer = setInterval(() => {
      this.timeLeft--;
      if (this.timeLeft == 0) {
        this.clearTimer();
        this.otpFlag = false;
        this.timeLeft = this.customMessage.otpLeftTime;
        this.isOtpGenerate = false;
        this.messageService.show(this.customMessage.otpTimeExpire, "error");
        //this.otpFromDirective.resetForm();
        this.otpForm.reset();
        this.validateEnrolForm.reset({ recaptcha: null });
        grecaptcha.reset();
      }
    }, 1000);
  }

  clearTimer() {
    this.timeLeft = this.customMessage.otpLeftTime;
    clearInterval(this.subscribeTimer);
  }

  verifyOTP(
    formDirective1: FormGroupDirective,
    formDirective2: FormGroupDirective
  ) {
    this.otpFromDirective = formDirective2;
    this.validateEnrolFromDirective = formDirective1;
    const entity = this.otpForm.value;
    this.validateEnrolService
      .otpValidation(entity.otpNumber, entity.enrolId)
      .subscribe(
        res => {
          this.productList = res.data.enrolproducts;
          this.relationList = res.data.relations;
          this.dependentProducts = res.data.dependentProducts;
          this.insuredName = res.data.insureName;
          this.groupPolicyName = res.data.groupPolicyName;
          this.clearTimer();
          this.resetFromSettings();
          this.notifyParentComponent();
        },
        error => {
          if (AppContentMessage.OTP_VALIDATION_Try_Limit_Exceeded == error.error.message) {
            this.clearTimer();
            this.resetFromSettings();
          }
          this.messageService.show(error.error.message, "error");
        }
      );
  }

  resetFromSettings() {
    if (this.validateEnrolFromDirective != null) {
      this.validateEnrolFromDirective.resetForm();
    }
    if (this.otpFromDirective != null) {
      this.otpFromDirective.resetForm();
    }
    this.validateEnrolForm.reset({ recaptcha: null });
    this.otpForm.reset();
    this.otpFlag = false;
    this.timeLeft = this.customMessage.otpLeftTime;
    this.isOtpGenerate = false;
    if(this.recaptchaEnabled){grecaptcha.reset();}
  }

  notifyParentComponent() {
    const data = {
      relationList: this.relationList,
      productList: this.productList,
      dependentProducts: this.dependentProducts,
      insuredName: this.insuredName,
      browserId: this.browserId,
      groupPolicyNo: this.groupPolicyNo,
      groupPolicyName: this.groupPolicyName,
      certificateNo: this.certificateNo,
      birthYear: this.birthYear,
      enrolId: this.enrolId,
      requestToken: this.requestToken
    }
    this.onValidOTP.emit(data);
  }

  resolved = (captchaKey: string) => {
    if(this.recaptchaEnabled){
      this.validateEnrolForm.patchValue({ recaptcha: captchaKey });
    }
  }

}
